<template>
    <!-- prettier-ignore -->
    <div class="login-container">
        <div class="login-bg"></div>
        <div class="login-body">
            <div class="login-box-body" v-loading="loading">
                <el-form class="login-form-container" label-width="80px" :model="form" label-position="left">
                    <div class="form-header">
                        <img src="@/assets/logo.svg" />
                        <div>登陆 IKRONG</div>
                    </div>
                    <div class="login-form-wrap">
                        <div class="login-form" v-if="!loginComplete">
                            <div>
                                <el-form-item label="账号" required :error="form.errors.loginId" size="small">
                                    <el-input v-model="form.loginId" placeholder="填写手机号码或账号" maxlength="11"
                                        @change="form.errors = {}"></el-input>
                                </el-form-item>
                                <el-form-item label="密码" required :error="form.errors.password" size="small">
                                    <el-input type="password" v-model="form.password" placeholder="填写密码"
                                        @change="form.errors = {}">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="form-footer" v-if="currentTab != 'qrcode' && !loginComplete">
                        <div class="policy-check">
                            <span class="policy-tips">
                                <span>登录即同意</span>
                                <el-button type="text" @click="openPolicy()">《隐私政策》</el-button>
                            </span>
                        </div>
                        <el-button type="primary" @click="form.login()" size="small">立即登录</el-button>
                    </div>
                </el-form>
            </div>
            <div class="login-box-footer">&copy;2022 ikrong.com</div>
        </div>
    </div>
</template>

<script>
import Utils from "@/utils/utils";
import { IdPasswordLoginController, QrcodeLoginController } from '@/utils/auth/login';
import { Messenger } from '@eslibs/messenger'

export default {
    data() {
        return {
            form: null,
            loginComplete: false,
            loading: false,
            currentTab: 'password'
        };
    },
    watch: {
        currentTab() {
            this.createCtrl()
        }
    },
    created() {
        this.createCtrl()
    },
    methods: {
        createCtrl() {
            this.form && this.form.destroy()
            if (this.currentTab == 'qrcode') {
                this.form = new QrcodeLoginController(this)
            } else {
                this.form = new IdPasswordLoginController(this)
            }
        },
        errorMessage(msg) {
            this.$elementUI.message.error(msg)
        },
        async afterLogin(token) {
            // 注册成功
            this.$elementUI.message.success('登录成功')
            const info = new URL(location.href)
            if (window.opener) {
                new Messenger({
                    namespace: 'ikrong-login',
                    postMessage(channelMessage) {
                        window.opener.postMessage(channelMessage, info.searchParams.get('from'));
                    },
                    process() { },
                    listener(cb) {
                        window.onmessage = e => cb(e.data)
                    },
                }).listen().echo().send('token', token).finally(() => {
                    window.close()
                })
                return
            }
            if (!info.searchParams.get('redirect')) {
                return
            }
            const redirect = new URL(info.searchParams.get('redirect'))
            redirect.searchParams.set('token', token)
            redirect.searchParams.set('systemType', info.searchParams.get('systemType'))
            location.href = redirect.toString()
        },
        openPolicy() {
            window.open(Utils.relativeURL("policy.html"), "_blank");
        },
        signup() {
            this.$router.push(`/signup?redirect=${encodeURIComponent(location.href)}`)
        }
    },
};
</script>

<style lang="scss" scoped>
.login-container {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .login-bg {
        flex: auto;
        background-image: url(https://bing.img.run/uhd.php);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }

    .login-body {
        flex: 500px 0 0;
        height: fit-content;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
        overflow: hidden;
        padding: 44px;
        user-select: none;

        .login-box-header {
            flex: 40px 0 0;
        }

        .login-box-body {
            flex: auto;
            overflow: hidden;
            overflow-y: auto;

            >.login-form-container {
                display: flex;
                flex-direction: column;
                height: 100%;

                .form-header {
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    >img {
                        width: 40px;
                    }
                }

                .login-form-wrap {
                    flex: auto;
                    overflow: auto;

                    ::deep .el-tabs__header {
                        width: 100%;
                    }
                }

                .form-footer {
                    flex: 55px 0 0;
                    display: flex;
                    column-gap: 20px;
                    align-items: center;
                    justify-content: space-between;

                    .policy-check {
                        ::v-deep {
                            .el-form-item {
                                margin-bottom: 4px;

                                .el-form-item__error {
                                    padding-top: 0;
                                    margin-top: -10px;
                                }
                            }
                        }

                        .policy-tips {
                            margin-left: 0;
                            font-size: 12px;
                            color: #606266;
                        }
                    }
                }
            }


            .login-form {
                padding-top: 20px;
            }
        }

        .login-box-footer {
            flex: 40px 0 0;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #b0b0b0;
            justify-content: center;
        }
    }
}
</style>